import { render, staticRenderFns } from "./SpecialProcessProvideExtraProductInfo.vue?vue&type=template&id=f7374fa2&scoped=true&"
import script from "./SpecialProcessProvideExtraProductInfo.vue?vue&type=script&lang=js&"
export * from "./SpecialProcessProvideExtraProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7374fa2",
  null
  
)

export default component.exports